exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-modal{max-width:1250px}.file-modal__title{font-size:1rem}.file-modal__header{position:-webkit-sticky;position:sticky;top:0;z-index:999;display:flex;align-items:center;padding:10px 1rem}.file-modal__body{text-align:center;min-height:80vh}.file-modal__image{width:100%;height:80vh;-o-object-fit:contain;object-fit:contain}.file-modal__office{height:80vh}.file-modal__error{font-size:1.5rem;height:80vh;display:flex;flex-direction:column;align-items:center;justify-content:center}", ""]);

// exports
